import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-h-profile',
  templateUrl: './h-profile.component.html',
  styleUrls: ['./h-profile.component.less']
})
export class HProfileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
